import { Button } from 'components'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ScaleLoader } from 'react-spinners'
import { getMyMembers } from 'service/CollectiveService'
import { createTask } from 'service/TaskService'
import { setMyMembers } from 'store/slices/CollectiveSlice'
import { postTask } from 'store/slices/TaskSlice'
import Notification from 'utils/Notifications'
import styles from './TaskForm.module.scss'
import TaskCoWorker from './components/TaskCoWorker/TaskCoWorker'
import TaskDeadline from './components/TaskDeadline/TaskDeadline'
import TaskResponsible from './components/TaskResponsible/TaskResponsible'
import TaskWatchers from './components/TaskWatchers/TaskWatchers'
import {
  setUpdatedStatusTask,
} from "store/slices/TaskSlice";
import { updateStatusTask } from "service/TaskService";

function TaskForm({ idstatement, typestatement, setRender, setState }) {
  const [loader, setLoader] = useState(false)

  const [CoWorker, setCoWorker] = useState([])
  const [Watchers, setWatchers] = useState([])
  const [Responsible, setResponsible] = useState([])
 
  const [deadline_date, setDeadlineDate] = useState(null)
  const [task_name, setTaskName] = useState('')

  const [description, setDescription] = useState('')
  const [subtasks] = useState([])

  //Checkboxes
  const [is_critical, setIsCriticalChecked] = useState(false)
  const [allow_change_deadline, setIsAllowChange] = useState(false)
  const [skip_dayoffs, setisSkipDayOff] = useState(false)
  const [check_after_finish, setIsCheckFinish] = useState(false)
  const [determ_by_subtasks, setIsDeterm] = useState(false)
  const [report_after_finish, setIsReportFinish] = useState(false)
  const [files_data, setFiles]  = useState([]);
  //Notifications
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  //Dispatch
  const dispatch = useDispatch()

  //Function

  const onFileChange = (event) => {
    setFiles(event.target.files);

  };
  const getData = async () => {
    try {
      let response = await getMyMembers('task',data)

      dispatch(
        setMyMembers({
          members: response.data,
        }),
      )
    } catch (error) {
      console.log("CHU")
    }
  }

  useEffect(() => {
    getData()
    setRender(true)
  }, [])

  const myTeam = useSelector((state) => state.collective.members)
  const confirmedEmployees = myTeam ? [myTeam.confirmed] : []
  const data = [confirmedEmployees.flat().filter((item) => item.flag)]
 

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (task_name === '') {
      setNotify({
        isOpen: true,
        message: 'Введите название задачи',
        type: 'warning',
        sound: 'warning',
      })
    } else if (allResponsible.length === 0) {
      setNotify({
        isOpen: true,
        message: 'Выберите ответственного',
        type: 'warning',
        sound: 'warning',
      })
    } else {
      event.preventDefault()

      let clipedStatement = ''
      if (idstatement === undefined) {
        clipedStatement = ''
      } else {
        clipedStatement = idstatement
      }
      setDeadlineDate(null)

      try {
        setLoader(true)
        let response = await createTask({
          task_name,
          is_critical,
          description,
          members: selectedPeople,
          deadline_date,
          allow_change_deadline,
          skip_dayoffs,
          check_after_finish,
          determ_by_subtasks,
          report_after_finish,
          subtasks,
          attached_document: String(clipedStatement),
        })
        dispatch(
          postTask({
            task_name: task_name,
            is_critical,
            description: description,
            members: selectedPeople,
            deadline_date,
            allow_change_deadline,
            skip_dayoffs,
            check_after_finish,
            determ_by_subtasks,
            report_after_finish,
            subtasks,
            attached_document: clipedStatement,
          }),
        )
        const formData = new FormData();
        const status_in_file = "status_in_file"
        formData.append('status_in_file', status_in_file);
        
        for (let i = 0; i < files_data.length; i++) {
          formData.append('files', files_data[i]);
        }
       
        const set_id = response.data.id
        let response1 = await updateStatusTask(set_id, formData);
        dispatch(setUpdatedStatusTask(response1.data));
        setNotify({
          isOpen: true,
          message: 'Задача успешно отправлена',
          type: 'success',
          sound: 'success',
        })

        setState({ isPaneOpen: false })
        setRender(true)
      } catch (error) {
        setNotify({
          isOpen: true,
          message: 'Ошибка',
          type: 'error',
          sound: 'error',
        })
        console.log(error.data)
      } finally {
        setLoader(false)
      }
    }
  }
  //UseSelector


  const allResponsible = Responsible.map(({ value }) => ({
    member_id: value,
    member_type: 'Ответственный',
  }))
  const allCoWorkers = CoWorker.map(({ value }) => ({
    member_id: value,
    member_type: 'Соисполнитель',
  }))
  const allWatchers = Watchers.map(({ value }) => ({
    member_id: value,
    member_type: 'Наблюдатель',
  }))

  const selectedPeople = [...allResponsible, ...allCoWorkers, ...allWatchers]

  return (
    <div className={styles.task_wrapper}>
      <form>
        <div className={styles.task_heading}>
          <div className={styles.added_raport}>
            {typestatement === undefined ? (
              ''
            ) : (
              <>
                <h4
                  style={{ paddingBottom: '15px' }}
                >{`Прикрепленный документ: ${typestatement}`}</h4>
              </>
            )}
          </div>
          <div className={styles.task_heading_top}>
            <input
              id="title"
              name="title"
              placeholder="Введите название задачи"
              className={styles.title_input}
              value={task_name}
              onChange={(e) => setTaskName(e.target.value)}
              maxLength={180}
            />
            <div className={styles.task_heading_right}>
              <div className={styles.checkbox}>
                <input
                  id="important"
                  name="title"
                  type="checkbox"
                  className={styles.title_input_check}
                  checked={is_critical}
                  onChange={() => setIsCriticalChecked(!is_critical)}
                />
                <span>Важная задача</span>
              </div>
            </div>
          </div>
          <textarea
            id="discription"
            name="discription"
            className={styles.discription_input}
            maxLength={2000}
            placeholder="Описание"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.shiftKey) {
                e.preventDefault() // Предотвращаем стандартное поведение
                setDescription(description + '\n') // Добавляем символ новой строки к описанию
              }
            }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className={styles.add_statement_file}>
        <input type="file" multiple  onChange={onFileChange} />
          <span>Прикрепление файла</span>
      </div>
        <div className={styles.task_options}>
          <TaskResponsible
            dataResponsible={data}
            setResponsible={setResponsible}
            isMilti={true}
            text={'Ответственный *'}
          />
          <TaskWatchers dataWatchers={data} setWatchers={setWatchers} />
          <TaskCoWorker dataCoWorker={data} setCoWorker={setCoWorker} />
          {/* <TaskDirector dataDirector={data} setDirector={setDirector} /> */}
          <TaskDeadline
            setIsAllowChange={setIsAllowChange}
            setisSkipDayOff={setisSkipDayOff}
            setIsCheckFinish={setIsCheckFinish}
            setIsDeterm={setIsDeterm}
            setDeadlineDate={setDeadlineDate}
            showChecks={true}
          />

          {/* <TaskResult setIsReportFinish={setIsReportFinish} /> */}
        </div>
        <div className={styles.task_footer}>
          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <Button className={styles.btn1} onClick={handleSubmit}>
              Создать задачу
            </Button>
          )}
        </div>
      </form>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default React.memo(TaskForm)
